// Submits the `PushSubscription` to 99designs Notifications application, so it
// can store in its records and reference them later when Pushing Notifications
import getCsrfToken from '../app/getCsrfToken';

export default function sendSubscriptionToBackEnd(subscription: PushSubscription) {
    return fetch('/notifications/xhr/push/subscription', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            csrf_token: getCsrfToken(),
            subscription,
        }),
        credentials: 'same-origin',
    });
}
